var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fidelity-page"},[_c('CategoryTitle',{attrs:{"category":_vm.category,"showOnMobile":true,"add-container":false}}),_c('img',{staticClass:"qr-code-img",attrs:{"src":_vm.imgsrc,"alt":"Fidelity QR code"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }